import React from 'react'
import { css } from 'emotion'
import DatePicker from 'antd/es/date-picker'
import 'antd/es/date-picker/style/css'
import { P1Bold } from 'src/components/Typography'
import { MAIN_FONT } from 'src/shared/TypographyStyles'
import { MAIN_COLORS, NEUTRAL_COLORS } from 'src/shared/ColorStyles'
import { useTheme } from 'src/shared/themeContext'

type Props = {
  placeholder?: string
  format?: string
  style?: Record<string, unknown>
  disabled?: boolean
  showToday?: boolean
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange?: any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  disabledDate?: any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value?: any
  label?: string
}

export default function({ disabled = false, label, ...rest }: Props) {
  const { spacing } = useTheme()
  const style = `
    -webkit-font-smoothing: antialiased;
    height: 44px;
    width: 100%;

    ${
      disabled
        ? `
      pointer-events: none;
      `
        : ''
    }

    &.ant-picker {
      border-radius: 5px;
      border-color: #E8E8E8;
      padding-left: 15px;
      transition: 0.3s all ease;

      &:hover {
        border-color: ${MAIN_COLORS.PRIMARY_BLUE};
      }

      &.ant-picker-focused {
        border-color: ${MAIN_COLORS.PRIMARY_BLUE};
      }
    }

    &.ant-picker > .ant-picker-input {
      font-family: ${MAIN_FONT};
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 22px;
      color: #121212;
    }

    & .ant-picker-input > input {
      font-size: 14px;
      color: #121212;
    }

    & .ant-picker-input > input::placeholder {
      font-size: 14px;
      color: ${NEUTRAL_COLORS.G400};
    }

    &.ant-picker.ant-picker-disabled {
      background: ${NEUTRAL_COLORS.G100};
      border: 1px solid ${NEUTRAL_COLORS.G200};
    }

    & .ant-picker-input > input[disabled] {
      color: ${NEUTRAL_COLORS.BLACK};
    }
  `

  return (
    <>
      {label && <P1Bold style={{ marginBottom: spacing.xs }}>{label}</P1Bold>}
      <DatePicker className={`${css(style)}`} disabled={disabled} {...rest} />
    </>
  )
}
